import * as React from "react";
import { IdLeagueGifts } from "../../constants/IdLeagueGifts";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonDefault } from "../generic/button-buy/ButtonDefault";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { ButtonSecondary } from "../generic/common/ButtonSecondary";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
export var ButtonDialogLeagueReward = function (_a) {
    var isDisabled = _a.isDisabled, buttonType = _a.buttonType, currentGift = _a.currentGift, onRequest = _a.onRequest;
    if (buttonType === IdLeagueGifts.LeagueFreeGift) {
        return (React.createElement(ButtonPrimary, { onClick: onRequest, disabled: isDisabled },
            React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collect })));
    }
    else if (currentGift && currentGift.cost) {
        var _b = getPrices(currentGift), originalPrice = _b[0], discountedPrice = _b[1];
        return (React.createElement(ButtonDefault, { component: ButtonSecondary, onClick: onRequest, disabled: isDisabled, icon: IdIcon.GoldIcn, amount: originalPrice, buffedAmount: discountedPrice }));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
var getPrices = function (currentGift) {
    var discountInfo = (currentGift.shownStat || []).find(function (element) { return element.bonusValue != undefined && element.valueType === "percentage"; });
    var discountFound = discountInfo != undefined;
    var discountedPrice = discountFound ? currentGift.cost[0].amount : undefined;
    var originalPrice = discountFound
        ? discountedPrice / discountInfo.bonusValue
        : currentGift.cost[0].amount;
    return [originalPrice, discountedPrice];
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/ButtonDialogLeagueReward.tsx
// module id = 2943
// module chunks = 3